import * as tslib_1 from "tslib";
import { Api } from '../api/api';
import * as i0 from "@angular/core";
import * as i1 from "../api/api";
var IsleService = /** @class */ (function () {
    function IsleService(api) {
        this.api = api;
    }
    IsleService.prototype.getTemplates = function (userName, appEnvironment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.api.http2.get("isle/templates/" + [userName, appEnvironment].join('/'))];
            });
        });
    };
    IsleService.prototype.getSegments = function (county, route) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.api.http2.get("isle/segments/" + county + "/" + route)];
            });
        });
    };
    IsleService.prototype.getSegment = function (county, route, segment, template, userName, usecrsforislebot, appEnvironment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!usecrsforislebot) {
                    template = (template) ? '?templateName=' + encodeURI(template) : '';
                    return [2 /*return*/, this.api.http2.get("isle/segments/" + county + "/" + route + "/" + segment + template + "/" + appEnvironment)];
                }
                else {
                    if (!template) {
                        template = '';
                    }
                    return [2 /*return*/, this.api.http2.get("isle/segments/" + county + "/" + route + "/" + segment + "/" + userName + "/" + template + "/" + appEnvironment)];
                }
                return [2 /*return*/];
            });
        });
    };
    IsleService.ngInjectableDef = i0.defineInjectable({ factory: function IsleService_Factory() { return new IsleService(i0.inject(i1.Api)); }, token: IsleService, providedIn: "root" });
    return IsleService;
}());
export { IsleService };
